import * as React from "react";
const SvgIcSubtract = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 10.5H3V13.5H21V10.5Z" fill="currentColor" /></svg>;
export default SvgIcSubtract;